import { Helmet } from 'react-helmet'
import Image from 'components/image'
import { track } from 'lib/analytics'
import { babylistUrl, storeBrandPagePath } from 'lib/urls'
import PlacementsInterstitialModal from 'components/modal/PlacementsInterstitialModal'
import { PLACEMENT_INTERSTITIAL_UNIT } from 'lib/placements/units'
import { UseQueryResult } from '@tanstack/react-query'
import { InjectedRouter, withRouter } from 'react-router'
import { useBrand } from '../../api/hooks'
import FrequentlyAskedQuestions from '../FrequentlyAskedQuestions/FrequentlyAskedQuestions'
import ShopByGuides from '../shop-by-guides'
import HeroProducts from './components/HeroProducts'

interface BrandPageProps {
  location: Location
  params: {
    slug: string
    brandId: number
  }
  router: InjectedRouter
}

const BrandPage = ({
  location,
  params: { brandId, slug },
  router,
}: BrandPageProps) => {
  const { data, isLoading } = useBrand(brandId) as UseQueryResult

  if (!data && isLoading) {
    return null
  }

  const {
    title,
    description,
    logoUrl,
    meta,
    name,
    frequentlyAskedQuestions,
    guides,
  } = (data as APIResponse.Brand) || {}

  return (
    <>
      <Helmet
        meta={[
          {
            name: 'description',
            content: meta.seoDescription,
          },
        ]}
        title={meta.seoTitle}
      >
        <link
          href={babylistUrl(storeBrandPagePath(slug, brandId))}
          rel="canonical"
        />
      </Helmet>
      <div className="flex col align-center justify-center well paxl">
        <Image
          alt={title}
          className="circle-mask"
          lazyLoad={false}
          src={logoUrl}
          style={{ width: 180, height: 180, background: '#e6e6e6' }}
        />
        <h1>{title}</h1>
        {description && <h2 className="text-center h5">{description}</h2>}
      </div>
      <HeroProducts
        brandId={brandId}
        brandName={name}
        guides={guides}
        location={location}
        router={router}
      />
      <ShopByGuides guides={guides} />
      {frequentlyAskedQuestions && frequentlyAskedQuestions.length > 0 && (
        <div className="mtxl">
          <FrequentlyAskedQuestions
            headerVariant="secondary"
            questions={frequentlyAskedQuestions}
          />
        </div>
      )}
      <PlacementsInterstitialModal
        eventLocation={track.EventLocation.STORE_MINUS_BRAND}
        unitId={PLACEMENT_INTERSTITIAL_UNIT}
      />
    </>
  )
}

export default withRouter(BrandPage)
